import * as React from 'react';
import { CircleAlert } from 'lucide-react';
import { Icon, Typography } from '@/components/common';
import { FileType, ReviewSignStatus } from '@/interfaces';
import {
	getDocumentDisplayName,
	getDocumentIcon,
} from '@/utils/caseDocumentation';

interface DocumentationRowAlertsProps {
	item: FileType;
	isReviewSign: boolean;
	reviewStatus: ReviewSignStatus;
	isDeclined: boolean;
}

export const DocumentationRowAlerts: React.FC<DocumentationRowAlertsProps> = ({
	item,
	isReviewSign,
	reviewStatus,
	isDeclined,
}) => (
	<div className="min-w-0 flex-1">
		<div
			className="flex items-center gap-x-2 min-w-0"
			title={getDocumentDisplayName(item)}
		>
			<Icon
				src={getDocumentIcon(item.file_name)}
				height={16}
				width={16}
				className="flex-shrink-0"
			/>
			<Typography
				type="regular-12"
				className="text-opacity-black truncate min-w-0"
			>
				{getDocumentDisplayName(item)}
			</Typography>
		</div>
		{isReviewSign &&
			!reviewStatus.isApproved &&
			item.file_name !== 'Retainer' && (
				<div className="flex items-center gap-2 mt-[10px]">
					<CircleAlert className="!text-main-red" size={16} />
					<Typography type="regular-12" className="text-main-red">
						{' '}
						This document has been declined.
						{isDeclined ? '' : ' Open to sign'}
					</Typography>
				</div>
			)}

		{!item.file_path && item.type !== 'FOLLOW_UP_DOCUMENT' && (
			<div className="flex items-center gap-2 mt-[10px]">
				<CircleAlert className="!text-main-orange" size={16} />
				<Typography type="regular-12" className="text-main-orange">
					{' '}
					This document was not provided.
				</Typography>
			</div>
		)}
	</div>
);
